import { render, staticRenderFns } from "./SambatechPlayer.vue?vue&type=template&id=75b10f83&scoped=true"
import script from "./SambatechPlayer.vue?vue&type=script&lang=js"
export * from "./SambatechPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b10f83",
  null
  
)

export default component.exports